<template>
	<div class="stickers-add">
		<StickerForm/>
	</div>
</template>

<script>
import * as stickerModule from '@/store/sticker'
import StickerForm from '@/components/stickers/StickerForm'

export default {
	components: {
		StickerForm
	},

	created () {
		const { name } = this.$route.params
		if (name) {
			const form = new FormData()
			form.append('set_name', this.stickerName)
			form.append('keyword', '')
			this.$store.dispatch('sticker/view', { form, name })
		}
	},

	beforeCreate () {
		if (!this.$store._modulesNamespaceMap['sticker/']) {
			this.$store.registerModule('sticker', stickerModule.default)
		}
	},

	computed: {
		stickerName () {
			return this.$route.params.name.split('-').join(' ')
		}
	}
}
</script>

<style lang="scss" scoped>
.stickers-add {
	width: 100%;
	height: 100%;
}
</style>
